import {
    Component,
    OnInit,
    OnDestroy,
    AfterContentChecked,
    ViewChild,
    ChangeDetectionStrategy,
} from '@angular/core';
import { Observable, combineLatest } from 'rxjs';
import { map, withLatestFrom, switchMap, tap } from 'rxjs/operators';
import { SubSink } from 'subsink';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { DocumentService } from 'src/app/acl-data/document/document.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IAclID } from 'src/app/acl-data/aclID.interface';
import { Alert } from 'src/app/acl-data/document/document.dto';

@Component({
    templateUrl: './document-print.component.html',
    styleUrls: ['./document-print.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPrintComponent implements AfterContentChecked {
    printing = false;
    private subs = new SubSink();

    showInfo = true;
    showdates = true;
    showbusinessOwner = true;
    showupi = true;
    showcomemnts = true;
    showlinked = true;
    shownotifications = true;

    future = true;
    past = false;
    trackTask = false;

    documentID$ = this.route.paramMap.pipe(
        map(v => v.get('documentID')),
        withLatestFrom(this.route.data),
        map(([idValue, routeValue]) => {
            return {
                id: idValue,
                objectStore: routeValue.parentMenu.data.id,
            } as IAclID;
        })
    );

    document$ = this.documentID$.pipe(
        switchMap(v => this.documentService.getByID(v.objectStore, v.id, true))
    );
    linkedDocuments$ = combineLatest([this.document$, this.documentID$]).pipe(
        // tap(v => console.log('Test', v)),
        switchMap(([doc, id]) =>
            this.documentService.getByIds(
                id.objectStore,
                doc.linkedDocuments,
                true
            )
        )
    );

    @ViewChild('toPrint', { static: false }) toPrint;

    constructor(
        private documentService: DocumentService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    ngAfterContentChecked(): void {
        if (this.printing) {
            this.printStep2();
        }
    }

    print = () => {
        this.printing = true;
    };

    printStep2 = () => {
        this.document$.subscribe(doc => {
            const data = document.getElementById('toPrint');
            html2canvas(data).then(canvas => {
                // Few necessary setting options
                const imgWidth = 200;
                const pageHeight = 295;
                const imgHeight = (canvas.height * imgWidth) / canvas.width;
                const heightLeft = imgHeight;

                const contentDataURL = canvas.toDataURL('image/png');
                const pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
                const position = 0;
                pdf.addImage(
                    contentDataURL,
                    'PNG',
                    0,
                    position,
                    imgWidth,
                    imgHeight
                );
                pdf.save(doc.propertiesObj.DocumentTitle); // Generated PDF
            });

            this.printing = false;
        });
    };

    close = () => {
        window.close();
    };

    trackChanged = event => {
        // console.log(!!event && event.checked);
        if (!!event && event.checked) {
            this.future = true;
        }
    };

    filterAlerts = (alerts: Alert[]) => {
        if (!alerts) {
            return [];
        } else {
            return alerts
                .filter(
                    v =>
                        (v.propertiesObj.AlertDueDate < new Date() &&
                            this.past) ||
                        (v.propertiesObj.AlertDueDate >= new Date() &&
                            this.future)
                )
                .filter(v => !this.trackTask || v.propertiesObj.AlertTrackTask);
        }
    };
}
